import { render, staticRenderFns } from "./RegSuccess.vue?vue&type=template&id=d4322444"
import script from "./RegSuccess.vue?vue&type=script&lang=js"
export * from "./RegSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports